/* NetworkDiscoveryExplorerLmrbComponent.js */

"use strict";
const GameEditor = require("@gluenetworks/game_editor");
const Registrations = require("../../../RegistrationNamespaces");
const Steve = require("@gluenetworks/steve_core").getInstance();
const _ = require("lodash");

class NetworkDiscoveryExplorerLmrbComponent extends GameEditor {
    constructor(
        logger,
        di,
        editorLayout,
        userSession,
        NetworkDiscoveryEntity,
        solutionManager,
        DataSyncConfig
    ) {
        super(logger, di);

        this._editorLayout = editorLayout;
        this._userSession = userSession;
        this._activeOrgId = userSession.activeOrganization.id;
        this._NetworkDiscoveryEntityDef = NetworkDiscoveryEntity;
        this._solutionManager = solutionManager;
        this._dataSyncConfig = DataSyncConfig;
        this._openEditorFromUrl = false;
        this._filterFromUrl = false;
        this._updateNameSpaces();

        this._registerDiscoveryExplorerListeners();

        const superRender = this.renderer.render;
        this.renderer.render = (args) => {
            return superRender.apply(this.renderer, args).then(() => {
                this.renderer._rootElem.classList.add("network-discovery-explorer-lmrb");

                return this.whenGameEditorStorageIsReady().then(() => {
                    const otherParams = _.get(Steve.router.getRouteDetails(), "rd", "");
                    if (otherParams.openEditor || !_.isEmpty(otherParams.selection)) {
                        this._openEditorFromUrl = {
                            open: otherParams.openEditor || false,
                            selectedIds: otherParams.selection,
                        };
                    }
                    if (!_.isEmpty(otherParams.filter) || !_.isUndefined(otherParams.filter)) {
                        this._filterFromUrl = true;
                    }

                    if (this._LMRBLayout.state.bottom.dockletClicked === true) {
                        this._gameEditorData.setData(
                            this._LMRBLayout.state.bottom._state.openedPartId,
                            "currentExplorerView"
                        );
                        this._LMRBLayout.state.bottom.dockletClicked = undefined;
                    }

                    const currentView = this._whereToRedirect();
                    this._switchSolution(currentView);

                    return;
                });
            });
        };
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _updateNameSpaces(withUpdate) {
        let solutionDefinition = this._solutionManager.getActiveSolution();
        let gameEditorViews = _.get(
            solutionDefinition,
            "networkDiscoveryExplorer.viewNamespaces",
            []
        );
        let gameEditorActions = _.get(
            solutionDefinition,
            "networkDiscoveryExplorer.actionNamespaces",
            []
        );

        this.setNamespaceGlobs(gameEditorViews.concat(gameEditorActions), !withUpdate);
    }

    _switchSolution(view = "") {
        if (this.currentSolutionName === "device_manager") {
            let currentExplorerView = this._gameEditorData.getData("currentExplorerView");
            if (!_.isEmpty(view)) {
                currentExplorerView = view;
            }
            this._gameEditorData.setData(currentExplorerView, "currentExplorerViewTemp");
            if (
                currentExplorerView &&
                currentExplorerView === Registrations.AUDIT_POLICY_EXPLORER_LMRB
            ) {
                this.openLMRBExplorer(Registrations.AUDIT_POLICY_EXPLORER_LMRB);
                /*} else if (currentExplorerView && currentExplorerView === Registrations.OS_CATALOG_EXPLORER_LMRB && this._isCatalogEnable) {
                this.openLMRBExplorer(Registrations.OS_CATALOG_EXPLORER_LMRB);*/
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.DATA_EXPLORER_LMRB
            ) {
                this.openLMRBExplorer(Registrations.DATA_EXPLORER_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.SITE_EXPLORER_ENTITY_LMRB
            ) {
                this.openLMRBExplorer(Registrations.SITE_EXPLORER_ENTITY_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.DEVICE_EXPLORER_ENTITY_LMRB
            ) {
                this.openLMRBExplorer(Registrations.DEVICE_EXPLORER_ENTITY_LMRB);
                // this.openLMRBExplorer(Registrations.NETWORK_DISCOVERY_EXPLORER_ENTITY_LMRB);
            } else if (
                currentExplorerView &&
                currentExplorerView === Registrations.IOT_DEVICE_EXPLORER_ENTITY_LMRB
            ) {
                this.openLMRBExplorer(Registrations.IOT_DEVICE_EXPLORER_ENTITY_LMRB);
            } else {
                this._cabinetCmpnt.selectView(Registrations.NETWORK_DISCOVERY_EXPLORER_GRID);
                // this._cabinetCmpnt.selectView(Registrations.DEVICE_EXPLORER_VIEW_GRID);
            }
            return;
        }
    }

    _registerDiscoveryExplorerListeners() {
        this._solutionManager.on(
            "activeSolutionChanged",
            (this._onSolutionChanged = this._onSolutionChanged.bind(this))
        );
        this._userSession.on(
            "OrganizationChange",
            (this._onOrganizationChange = this._onOrganizationChange.bind(this))
        );
        this._cabinetCmpnt.on(
            "ExplorerChanged",
            (this._onExplorerChanged = this._onExplorerChanged.bind(this))
        );
        Steve.router.on(
            "RouteDetailsChanged",
            (this._onRouteInfoChanged = _.throttle(this._onRouteInfoChanged.bind(this), 500))
        );
    }

    _unregisterDiscoveryExplorerListeners() {
        if (this._solutionManager) {
            this._solutionManager.removeListener("activeSolutionChanged", this._onSolutionChanged);
        }
        if (this._userSession) {
            this._userSession.removeListener("OrganizationChange", this._onOrganizationChange);
        }
        if (this._cabinetCmpnt) {
            this._cabinetCmpnt.removeListener("ExplorerChanged", this._onExplorerChanged);
        }
        if (Steve.router) {
            Steve.router.removeListener("RouteDetailsChanged", this._onRouteInfoChanged);
        }
    }

    whenInitialized() {
        return Promise.resolve().then(() => {
            if (!Steve.controlAppNav.xDomeEnabled) {
                this.hideBarView(Registrations.NETWORK_DISCOVERY_SWITCH_TO_IOT_DEVICE_EXPLORER);
                this._LMRBLayout.state.bottom.removePart(
                    Registrations.IOT_DEVICE_EXPLORER_ENTITY_LMRB
                );
            }
            return Promise.resolve();
        });
    }

    launchNetworkDiscoveryEditor(editorState, launchOpts) {
        const planId = launchOpts.id;
        const policesIds = _.concat(launchOpts.ids || [], launchOpts.id || []);
        const stringToHash = policesIds.join("_");
        launchOpts = _.omit(launchOpts, ["id", "ids"]);

        this.generateHash(stringToHash)
            .catch((error) => this._logger.warn({error}))
            .then((tabId) => {
                launchOpts = _.assign({}, launchOpts, {
                    id: tabId,
                    planId,
                });
                return this._editorLayout.launchEditor(
                    editorState,
                    Registrations.NETWORK_DISCOVERY_EDITOR,
                    launchOpts
                );
            });
    }

    updateFilter(filterString) {
        if (_.isEmpty(filterString)) {
            this._reestablishFeed();
        } else {
            this._reestablishFeed(filterString);
        }
    }

    generateHash(stringToHash) {
        const encoder = new TextEncoder();
        const data = encoder.encode(stringToHash);

        return window.crypto.subtle.digest("SHA-256", data).then(hexString);

        function hexString(buffer) {
            const byteArray = new Uint8Array(buffer);
            const hexCodes = [...byteArray].map((value) => {
                const hexCode = Number(value).toString(16);
                return hexCode.padStart(2, "0");
            });
            return hexCodes.join("");
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    shutdown() {
        let shutdowns = [];
        return Promise.all(shutdowns).then(
            () => {
                this._unregisterDiscoveryExplorerListeners();
                this._userSession = undefined;
                this._editorLayout = undefined;
                this._NetworkDiscoveryEntityDef = undefined;
                this._filterFromUrl = undefined;
                return super.shutdown();
            },
            (err) => {
                this._logger.warn(
                    {error: err},
                    "DeviceExplorerEntityLmrbComponent.shutdown() error"
                );
            }
        );
    }

    /*******************************************/
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onSolutionChanged(/*newActiveSolution*/) {
        this.shutdown();
    }

    _onOrganizationChange(newOrg, oldOrg) {
        this._unregisterDiscoveryExplorerListeners();
        if (!_.isUndefined(newOrg) && !_.isUndefined(oldOrg) && newOrg.id !== oldOrg.id) {
            this.renderer.render().then(() => {
                this._registerDiscoveryExplorerListeners();
            });
        }
    }

    _onExplorerChanged() {
        this.shutdown();
    }

    _onRouteInfoChanged() {
        if (event && event.oldURL !== event.newURL) {
            const currentView = this._whereToRedirect();
            if (
                currentView &&
                this._gameEditorData.getData("currentExplorerViewTemp") !== currentView
            ) {
                this._gameEditorData.setData(currentView, "currentExplorerViewTemp");
                this._gameEditorData.setData(currentView, "currentExplorerView");
                this._cabinetCmpnt.emit("ExplorerChanged");
                this.openLMRBExplorer(currentView);
            }
        }
    }

    _whereToRedirect() {
        let currentView = "";
        if (_.get(Steve.router.getRouteDetails(), "exp", false)) {
            let currentViewName = _.get(Steve.router.getRouteDetails(), "exp", "");
            if (this.currentSolutionName === "device_manager") {
                switch (currentViewName) {
                    case "device":
                        currentView = Registrations.DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                    case "site":
                        currentView = Registrations.SITE_EXPLORER_ENTITY_LMRB;
                        break;
                    case "network_discovery":
                        currentView = Registrations.NETWORK_DISCOVERY_EXPLORER_ENTITY_LMRB;
                        break;
                    case "iot_device":
                        currentView =
                            Steve.controlAppNav && Steve.controlAppNav.xDomeEnabled
                                ? Registrations.IOT_DEVICE_EXPLORER_ENTITY_LMRB
                                : Registrations.DEVICE_EXPLORER_ENTITY_LMRB;
                        break;
                }
            }
        }

        return currentView;
    }
}

module.exports = NetworkDiscoveryExplorerLmrbComponent;

NetworkDiscoveryExplorerLmrbComponent.$inject = [
    "$teve.logger",
    "$teve.di",
    "EditorLayout.EditorLayout",
    "$teve.userSession",
    "$teve.entities.NetworkDiscoveryPlan",
    "$teve.solutionsManager",
    "$teve.entities.DataSyncConfig",
];
NetworkDiscoveryExplorerLmrbComponent.$supportedQuadrants = ["bottom"];
NetworkDiscoveryExplorerLmrbComponent.$defaultQuadrants = ["bottom"];
NetworkDiscoveryExplorerLmrbComponent.$iconRepoName = "networkdiscovery.network_discovery";
NetworkDiscoveryExplorerLmrbComponent.$openedByDefault = false;
NetworkDiscoveryExplorerLmrbComponent.$displayName = "Network Discovery Plan Explorer";
